var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3709 3.41642C12.6999 3.56292 12.9118 3.88929 12.9118 4.24939V19.7507C12.9118 20.1108 12.6999 20.4372 12.3709 20.5837C12.042 20.7302 11.6576 20.6694 11.39 20.4285L7.09084 16.5593H3.79337C3.28978 16.5593 2.88153 16.151 2.88153 15.6474V8.35268C2.88153 7.84909 3.28978 7.44084 3.79337 7.44084H7.09084L11.39 3.57162C11.6576 3.33072 12.042 3.26991 12.3709 3.41642ZM11.0881 6.29681L8.05074 9.03045C7.88331 9.18115 7.66601 9.26453 7.44075 9.26453H4.70522V14.7356H7.44075C7.66601 14.7356 7.88331 14.819 8.05074 14.9697L11.0881 17.7033V6.29681ZM14.5791 14.5792C16.0035 13.1548 16.0035 10.8454 14.5791 9.42103L15.8687 8.13149C18.0053 10.2681 18.0053 13.7322 15.8687 15.8687L14.5791 14.5792ZM17.1581 6.84188C20.0069 9.69066 20.0069 14.3094 17.1581 17.1582L18.4476 18.4478C22.0086 14.8868 22.0086 9.11331 18.4476 5.55234L17.1581 6.84188Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.b7dcf5fbb62b4772bcdc9cdb52732410.svg";
export { ForwardRef as ReactComponent };